/* -------------------------------------------------------------------------- */
/*                                    页面权限                                 */
/* -------------------------------------------------------------------------- */

// 挂牌列表
export const LISTING_LIST_PAGE_UUID = '1b26e824-d523-4e3d-8099-65190996ca73'
